import { render, staticRenderFns } from "./otherIncome.vue?vue&type=template&id=4efc0dfc&scoped=true"
import script from "./otherIncome.vue?vue&type=script&lang=js"
export * from "./otherIncome.vue?vue&type=script&lang=js"
import style0 from "./otherIncome.vue?vue&type=style&index=0&id=4efc0dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc0dfc",
  null
  
)

export default component.exports